import type { UserResponse } from '$lib/api/types';

export function getAuthenticatedEntryPath(user: UserResponse | null): string {
	if (!user) return '/login';
	if (user.role === 'SUPER_ADMIN') return '/admin';
	if (user.companyId === null || user.companyId === undefined) return '/company/setup';
	if (user.role === 'EMPLOYEE') return '/home';
	return '/dashboard';
}
